import { render } from "./Canhoto.vue?vue&type=template&id=705bae82&scoped=true"
import script from "./Canhoto.vue?vue&type=script&lang=js"
export * from "./Canhoto.vue?vue&type=script&lang=js"

import "./Canhoto.vue?vue&type=style&index=0&id=705bae82&scoped=true&lang=css"

import exportComponent from "/var/www/ambientaly/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705bae82"]])

export default __exports__